<template>
    <div id="contents" class="pkv4-wrap">
        <div id="imageContainer">
            <img src="@/assets/images/goods/v4/pk/icon-pk.png" />
            <img src="@/assets/images/goods/v4/pk/bg-pk.png" />
        </div>
        <img
            v-show="!isLoading && isAllImg"
            class="top-bg"
            src="@/assets/images/goods/v4/pk/bg-pk.png"
        />
        <div class="pkv4-scroll" v-show="!isLoading && isAllImg">
            <img
                class="icon-pk"
                src="@/assets/images/goods/v4/pk/icon-pk.png"
            />
            <div
                v-if="oCategory.goods && oCategory.goods.length > 1"
                class="pk-product"
            >
                <div class="product-item">
                    <div
                        class="img-box"
                        v-if="!oCategory?.goods[0].album.length"
                    >
                        <img
                            class="img"
                            fit="contain"
                            :src="oCategory.goods[0].mobile_thumb"
                        />
                        <img
                            class="tag"
                            style="width: 28px; height: 36px"
                            src="@/assets/images/goods/v4/pk/icon-star-tag.png"
                        />
                    </div>

                    <div class="banner-box" v-else>
                        <van-swipe
                            class="swiper"
                            :autoplay="3000"
                            :touchable="false"
                            @change="onChangeLeft"
                            :initial-swipe="nBannerIndexLeft"
                        >
                            <template
                                v-for="(item, index) in oCategory.goods[0]
                                    .album"
                            >
                                <van-swipe-item
                                    class="swiper-item"
                                    :class="{
                                        active: index == nBannerIndexLeft,
                                    }"
                                >
                                    <img
                                        class="img"
                                        fit="contain"
                                        :src="item.file_url"
                                    />
                                </van-swipe-item>
                            </template>
                            <!-- <template #indicator>
                                <div class="custom-indicator">{{ nBannerIndexLeft + 1 }}/{{oCategory.goods[0].album.length}}</div>
                            </template> -->
                        </van-swipe>
                        <img
                            class="tag"
                            style="width: 28px; height: 36px"
                            src="@/assets/images/goods/v4/pk/icon-star-tag.png"
                        />
                    </div>
                    <div class="info-box">
                        <div class="box">
                            <img
                                v-if="false"
                                class="close-btn"
                                src="@/assets/images/goods/v4/pk/icon-close.png"
                            />
                            <div class="title">
                                {{ oCategory.goods[0].goods_name }}
                            </div>
                            <div class="options left">
                                <div
                                    v-if="!isCollectInfo && !isPad"
                                    class="item"
                                    @click="cutFun(oCategory.goods[0].id)"
                                >
                                    <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-cut-blue.png"
                                    />
                                    更换
                                </div>
                                <div
                                    v-if="oCategory.goods[0].link"
                                    class="item"
                                    @click="linkFun(oCategory.goods[0].link)"
                                >
                                    <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-3d-blue.png"
                                    />
                                    3D展示
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="product-item">
                    <div
                        class="img-box"
                        v-if="!oCategory?.goods[1].album.length"
                    >
                        <img
                            class="img"
                            fit="contain"
                            :src="oCategory.goods[1].mobile_thumb"
                        />
                        <!-- <img
                            class="tag"
                            v-if="oCategory.goods[1].is_star"
                            src="@/assets/images/goods/v4/pk/icon-star-tag1.png"
                        /> -->
                    </div>
                    <div class="banner-box" v-else>
                        <van-swipe
                            class="swiper"
                            :autoplay="3000"
                            :touchable="false"
                            lazy-render
                            @change="onChangeRight"
                            :initial-swipe="nBannerIndexRight"
                        >
                            <template
                                v-for="(item, index) in oCategory.goods[1]
                                    .album"
                            >
                                <van-swipe-item
                                    class="swiper-item"
                                    :class="{
                                        active: index == nBannerIndexRight,
                                    }"
                                >
                                    <img
                                        class="img"
                                        fit="contain"
                                        :src="item.file_url"
                                    />
                                </van-swipe-item>
                            </template>
                            <!-- <template #indicator>
                                <div class="custom-indicator">{{ nBannerIndexLeft + 1 }}/{{oCategory.goods[0].album.length}}</div>
                            </template> -->
                        </van-swipe>
                        <!-- <img
                            class="tag"
                            v-if="oCategory.goods[1].is_star"
                            src="@/assets/images/goods/v4/pk/icon-star-tag1.png"
                        /> -->
                    </div>
                    <div class="info-box info-box-orange">
                        <div class="box">
                            <img
                                v-if="false"
                                class="close-btn"
                                src="@/assets/images/goods/v4/pk/icon-close.png"
                            />
                            <div class="title">
                                {{ oCategory.goods[1].goods_name }}
                            </div>
                            <div class="options right">
                                <div
                                    v-if="!isCollectInfo && !isPad"
                                    class="item"
                                    @click="cutFun(oCategory.goods[1].id)"
                                >
                                    <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-cut-orange.png"
                                    />
                                    更换
                                </div>
                                <div
                                    v-if="oCategory.goods[1].link"
                                    class="item"
                                    @click="linkFun(oCategory.goods[1].link)"
                                >
                                    <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-3d-orange.png"
                                    />
                                    3D展示
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="edit-area" v-if="has_reason">
                <div
                    v-if="!isCollectInfo && !isPad"
                    class="top-right"
                    @click="touchEdit"
                >
                    <img
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-edit.png"
                    />
                    <span>{{ !isEdit ? "编辑" : "保存" }}</span>
                </div>
                <div class="title">
                    <img
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-praise-blue1.png"
                    />
                    <span>推荐理由</span>
                </div>
                <div class="main">
                    <span v-if="!isEdit">{{ recom_reason }}</span>
                    <el-input
                        v-else
                        ref="textarea"
                        autofocus
                        clearable
                        type="textarea"
                        autosize
                        placeholder="请输入推荐理由"
                        resize="none"
                        v-model="recom_reason"
                        :readonly="!isEdit"
                    />
                </div>
            </div>
            <div
                class="share-box"
                :style="{
                    opacity: !isCollectInfo && !isPad && isShare ? 1 : 0,
                    bottom: boxBottom + 'px',
                    // top: boxTop + 'px',
                    // top: boxTop ? boxTop + 'px' : '175px',
                }"
            >
                <div class="box" v-if="!isCollectInfo && !isPad && isShare">
                    <div class="title">分享内容</div>
                    <div class="all" @click="touchSelectAll">全选</div>
                </div>
                <div
                    class="box-close"
                    :style="{ top: boxClose + 'px' }"
                    @click="isShare = false"
                >
                    <img
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-box-close.png"
                    />
                </div>
            </div>
            <template v-for="(attr, index) in oCategory.attr">
                <div
                    :class="{
                        'parameter-box': true,
                        'parameter-box2': index == 0,
                    }"
                    :style="{
                        paddingTop: attr.key_name == '' ? '0.25rem' : '0',
                    }"
                >
                    <div v-if="!isCollectInfo && !isPad">
                        <div v-if="attr.key_name" class="title">
                            <img
                                class="dot1"
                                src="@/assets/images/goods/v4/pk/icon-title.png"
                            />
                            {{ attr.key_name }}
                            <div class="dot2"></div>
                            <div
                                v-if="!isCollectInfo && !isPad && isShare"
                                class="select-box"
                                @click="touchSelectAttr(attr, index)"
                            >
                                <img
                                    v-show="attr.isSelect && attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-on.png"
                                />
                                <img
                                    v-show="!attr.isSelect && !attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-off.png"
                                />
                                <img
                                    v-show="attr.isSelect && !attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-half.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div
                            v-if="attr.key_name && attr.isSelect"
                            class="title"
                        >
                            <img
                                class="dot1"
                                src="@/assets/images/goods/v4/pk/icon-title.png"
                            />
                            {{ attr.key_name }}
                            <div class="dot2"></div>
                            <div
                                v-if="!isCollectInfo && !isPad && isShare"
                                class="select-box"
                                @click="touchSelectAttr(attr, index)"
                            >
                                <img
                                    v-show="attr.isSelect && attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-on.png"
                                />
                                <img
                                    v-show="!attr.isSelect && !attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-off.png"
                                />
                                <img
                                    v-show="attr.isSelect && !attr.isAllSelect"
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-tick-half.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="attr-tag-box">
                        <div class="left">
                            <template v-for="(item, index) in attr.list">
                                {{ JSON.stringify(item.attr_tage?.length) }}
                                <div
                                    class="attr-tag"
                                    v-if="
                                        item.attr_tag?.length &&
                                        item.attr_tag[0]
                                    "
                                >
                                    <!-- <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-like-star.png"
                                    /> -->
                                    <span>{{ item.attr_tag[0] }}</span>
                                </div>
                            </template>
                        </div>
                        <div class="right">
                            <template v-for="(item, index) in attr.list">
                                {{ JSON.stringify(item.attr_tage?.length) }}
                                <div
                                    class="attr-tag"
                                    v-if="
                                        item.attr_tag?.length &&
                                        item.attr_tag[1]
                                    "
                                >
                                    <!-- <img
                                        class="icon"
                                        src="@/assets/images/goods/v4/pk/icon-like-star.png"
                                    /> -->
                                    <span>{{ item.attr_tag[1] }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div v-for="(item, i) in attr.list" class="item-box">
                        <div
                            :class="{
                                value: true,
                                'value-top': i == 0,
                                'value-bottom': i == attr.list.length - 1,
                            }"
                        >
                            <template v-if="item.attr_item[0] == '是'">
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-blue.png"
                                />
                            </template>
                            <template v-else-if="item.attr_item[0] == '否'">
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-not.png"
                                />
                            </template>
                            <template v-else-if="item.attr_item[0]">
                                <span
                                    class="center"
                                    :class="
                                        item.attr_name == '延时模式'
                                            ? 'centerTop'
                                            : ''
                                    "
                                    v-if="item.attr_name == '延时模式'"
                                    style="margin: 0 auto"
                                    >{{ item.attr_item[0] }}</span
                                >
                                <span class="center" v-else>{{
                                    item.attr_item[0]
                                }}</span>
                            </template>
                            <template v-else>
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-not.png"
                                />
                            </template>
                            <template
                                v-if="
                                    item.attr_item[0] &&
                                    item.is_win == item.attr_item[0]
                                "
                            >
                                <!-- <img v-if="item.attr_item[0] == '是' || item.attr_item[0] == '否'" class="praise" src="@/assets/images/goods/v4/pk/icon-praise-blue.png" /> -->
                                <img
                                    class="praise"
                                    src="@/assets/images/goods/v4/pk/icon-praise-blue.png"
                                />
                            </template>
                        </div>
                        <div
                            :class="{
                                item: true,
                                'item-bottom': i == attr.list.length - 1,
                            }"
                        >
                            <div class="name">
                                <span
                                    v-if="item.attr_name == '延时模式'"
                                    style="display: block; margin: 0px auto"
                                    >{{ item.attr_name }}</span
                                >
                                <!-- <span v-else>{{ item.attr_name }}</span> -->
                                <div v-html="item.attr_name" v-else></div>
                            </div>
                            <div
                                v-if="
                                    !item.attr_text &&
                                    item.attr_name == '延时模式'
                                "
                                class="sub sub1"
                            ></div>
                            <div
                                v-else-if="
                                    item.attr_text &&
                                    item.attr_name == '延时模式'
                                "
                                class="sub sub1"
                            >
                                {{ item.attr_text }}
                            </div>
                            <div v-else-if="item.attr_text" class="sub">
                                {{ item.attr_text }}
                            </div>
                        </div>
                        <div
                            :class="{
                                'value value2': true,
                                'value-top': i == 0,
                                'value-bottom': i == attr.list.length - 1,
                            }"
                        >
                            <template v-if="item.attr_item[1] == '是'">
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-orange.png"
                                />
                            </template>
                            <template v-else-if="item.attr_item[1] == '否'">
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-not.png"
                                />
                            </template>
                            <template v-else-if="item.attr_item[1]">
                                <span
                                    class="center"
                                    :class="
                                        item.attr_name == '延时模式'
                                            ? 'centerTop'
                                            : ''
                                    "
                                    v-if="item.attr_name == '延时模式'"
                                    style="margin: 0 auto"
                                    >{{ item.attr_item[1] }}</span
                                >
                                <span class="center" v-else>{{
                                    item.attr_item[1]
                                }}</span>
                            </template>
                            <template v-else>
                                <img
                                    class="icon center"
                                    src="@/assets/images/goods/v4/pk/icon-select-not.png"
                                />
                            </template>
                            <template
                                v-if="
                                    item.attr_item[1] &&
                                    item.is_win == item.attr_item[1]
                                "
                            >
                                <!-- <img v-if="item.attr_item[1] == '是' || item.attr_item[1] == '否'" class="praise" src="@/assets/images/goods/v4/pk/icon-praise-orange.png" /> -->
                                <img
                                    class="praise"
                                    src="@/assets/images/goods/v4/pk/icon-praise-orange.png"
                                />
                            </template>
                        </div>
                        <div
                            v-if="!isCollectInfo && !isPad && isShare"
                            :class="
                                item.attr_name == '延时模式'
                                    ? 'select-box1'
                                    : 'select-box'
                            "
                            @click="touchSelectItem(item, index, i)"
                        >
                            <img
                                v-show="item.isSelect"
                                class="icon"
                                src="@/assets/images/goods/v4/pk/icon-tick-on2.png"
                            />
                            <img
                                v-show="!item.isSelect"
                                class="icon"
                                src="@/assets/images/goods/v4/pk/icon-tick-off2.png"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <div
                v-if="oCategory.topic && oCategory.topic.length > 1"
                :class="{
                    'parameter-box-last': true,
                    'parameter-box': true,
                    'parameter-box2': oCategory.attr.length == 0,
                }"
            >
                <div class="title">
                    <img
                        class="dot1"
                        src="@/assets/images/goods/v4/pk/icon-title.png"
                    />
                    用户口碑
                    <div class="dot2"></div>
                </div>
                <div class="topic-box">
                    <div v-if="oCategory.topic[0]" class="topic">
                        <div class="top">
                            <div class="count">
                                累计评价<span class="num">
                                    {{ oCategory.topic[0].count }} </span
                                >人
                            </div>
                            <div
                                class="blue"
                                @click="touchMoreShow(oCategory.goods[0].id)"
                            >
                                查看评价
                                <img
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-right-blue.png"
                                />
                            </div>
                        </div>
                        <div class="tag-box">
                            <div
                                v-for="(tag, index) in oCategory.topic[0]
                                    .arrTag"
                                class="tag"
                            >
                                {{ tag }}
                            </div>
                        </div>
                        <div class="content">
                            <div class="info">
                                <img
                                    class="avatar"
                                    :src="oCategory.topic[0].avatar"
                                />
                                <div class="name-box">
                                    <div class="name">
                                        {{
                                            oCategory.topic[0].nickname || "--"
                                        }}
                                    </div>
                                    <div class="star">
                                        <img
                                            v-for="score in oCategory.topic[0]
                                                .nScore"
                                            class="icon"
                                            src="@/assets/images/goods/v4/pk/icon-star-blue.png"
                                        />
                                        <img
                                            v-for="score in 5 -
                                            oCategory.topic[0].nScore"
                                            class="icon"
                                            src="@/assets/images/goods/v4/pk/icon-start-d.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="address-box">
                                <img
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-address.png"
                                />
                                <div class="address">
                                    {{ oCategory.topic[0].plot_name }}
                                </div>
                            </div>
                            <div class="text">
                                {{ oCategory.topic[0].comment }}
                            </div>
                            <div class="time">
                                {{ oCategory.topic[0].createdate }}
                            </div>
                        </div>
                    </div>
                    <div v-if="oCategory.topic[1]" class="topic topic2">
                        <div class="top">
                            <div class="count">
                                累计评价<span class="num">
                                    {{ oCategory.topic[1].count }} </span
                                >人
                            </div>
                            <div
                                class="orange"
                                @click="touchMoreShow(oCategory.goods[1].id)"
                            >
                                查看评价
                                <img
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-right-orange.png"
                                />
                            </div>
                        </div>
                        <div class="tag-box">
                            <div
                                v-for="(tag, index) in oCategory.topic[1]
                                    .arrTag"
                                class="tag"
                            >
                                {{ tag }}
                            </div>
                        </div>
                        <div class="content">
                            <div class="info">
                                <img
                                    class="avatar"
                                    :src="oCategory.topic[1].avatar"
                                />
                                <div class="name-box">
                                    <div class="name">
                                        {{
                                            oCategory.topic[1].nickname || "--"
                                        }}
                                    </div>
                                    <div class="star">
                                        <img
                                            v-for="score in oCategory.topic[1]
                                                .nScore"
                                            class="icon"
                                            src="@/assets/images/goods/v4/pk/icon-star-orange.png"
                                        />
                                        <img
                                            v-for="score in 5 -
                                            oCategory.topic[1].nScore"
                                            class="icon"
                                            src="@/assets/images/goods/v4/pk/icon-start-d.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="address-box">
                                <img
                                    class="icon"
                                    src="@/assets/images/goods/v4/pk/icon-address.png"
                                />
                                <div class="address">
                                    {{ oCategory.topic[1].plot_name }}
                                </div>
                            </div>
                            <div class="text">
                                {{ oCategory.topic[1].comment }}
                            </div>
                            <div class="time">
                                {{ oCategory.topic[1].createdate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-box" v-if="!isCollectInfo && !isPad"></div>
        </div>
        <div class="pkv4-bottom" v-if="!isCollectInfo && !isPad">
            <div class="left">
                <div class="item" @click="touchShare">
                    <img
                        v-if="!isShare"
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-trans.png"
                    />
                    <img
                        v-else
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-trans-active.png"
                    />
                    <span>{{ isShare ? "分享" : "选择分享" }}</span>
                </div>
                <div class="item" @click="touchCollect">
                    <img
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-collect.png"
                    />
                    <span>收藏</span>
                </div>
                <div class="item" @click="touchSame">
                    <img
                        v-if="!isAll"
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-eye.png"
                    />
                    <img
                        v-else
                        class="icon"
                        src="@/assets/images/goods/v4/pk/icon-eye-active.png"
                    />
                    <span>仅看差异</span>
                </div>
            </div>
            <div class="right" @click="touchPriority">
                <div class="jg" @click="isPriority = true">
                    <img
                        v-if="isPriority"
                        src="@/assets/images/goods/v4/pk/pk-jg-active.png"
                    />
                    <img v-else src="@/assets/images/goods/v4/pk/pk-jg.png" />
                </div>
                <div class="pz" @click="isPriority = false">
                    <img
                        v-if="isPriority"
                        src="@/assets/images/goods/v4/pk/pk-pz.png"
                    />
                    <img
                        v-else
                        src="@/assets/images/goods/v4/pk/pk-pz-active.png"
                    />
                </div>
            </div>
        </div>
        <div class="guide" v-show="showGuide" @click="showGuide = false">
            <img
                v-if="false"
                class="share_hand"
                src="~@/assets/images/user/housev2/share_hand.png"
            />
            <div
                class="share_hint"
                :style="{
                    bottom: pkBottom ? pkBottom + 'px' : '75px',
                }"
            >
                <img
                    v-if="false"
                    class="share_icon"
                    src="~@/assets/images/user/housev2/share_icon.png"
                />
                <p>点击右上角“. . .” 分享给好友</p>
            </div>
        </div>
    </div>
</template>
<script>
// import store from "@/store";
import oApi from "@/js/goodsv4.js";
import { Toast } from "vant";
import Vue from "vue";
import { Input } from "element-ui";
Vue.use(Input);

export default {
    name: "index",
    components: {},
    data() {
        return {
            isAllImg: false,
            isLoading: false,
            isShow: false,
            query: {},
            isAll: false,
            isPriority: true,
            isCollect: false,
            oCategory: {},
            isEdit: false,
            recom_reason: "",
            has_reason: false,
            isCollectInfo: false,
            nBannerIndexLeft: 0,
            nBannerIndexRight: 0,
            albumLeft: [],
            albumRight: [],
            shareUrl: "", //分享链接
            isShowToast: false, //弹窗显示
            toastType: 1, //类型
            isPad: false,
            isShare: false,
            boxBottom: null,
            boxClose: null,
            scrollTimer: null,
            lastScrollTop: 0, // 上一次的滚动位置
            scrollDownDistance: 0, // 向下滚动的总距离
            scrollUpDistance: 0, // 向上滚动的总距离
            collectId: "",
            attrArr: [],
            showGuide: false,
            isFirst: true,
            boxTop: "",
            pkBottom: "",
        };
    },
    watch: {
        oCategory(newVal, oldVal) {
            console.log(newVal);
            this.goShare();
        },
    },
    beforeCreate() {
        console.log("beforeCreate");
        Toast.loading({
            duration: 0,
            message: "加载中...",
            forbidClick: true,
        });
        this.isLoading = true;
    },
    created() {
        console.log("created");
        this.query = this.$route.query;
        // debugger
        // Toast({
        //     message: `id:${this.query.id}`,
        //     duration: 3000,
        // });

        // window.$init(() => {
        Promise.all([this.getGoodsComparesFun()])
            .then(() => {
                // this.setFontSize();
                this.isShow = true;
                // Toast.clear();
                // this.isLoading = false;
            })
            .catch((err) => {
                // Toast.clear();
                // this.isLoading = false;
                console.log(err, "created err");
            });
        // });
    },
    mounted() {
        this.getImg();
        this.getHeight();
        // this.setHeight();
        window.addEventListener("scroll", this.handleScroll);

        // this.$nextTick(() => {
        //     this.adjustTextareaHeight(); // 手动触发高度调整
        // });
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        setHeight() {
            setTimeout(function () {
                document.querySelector(".share-box").style.top = this.boxTop
                    ? this.boxTop + "px"
                    : "175px";
            }, 500);
        },
        getImg() {
            const images = document.querySelectorAll("#imageContainer img");
            let loadedCount = 0;
            let that = this;

            function checkAllImagesLoaded() {
                if (loadedCount === images.length) {
                    console.log("所有图片都已加载完成！");
                    console.log(document.querySelector(".share-box").style.top);
                    // 可以在这里返回值或调用其他函数
                    that.isAllImg = true;
                    Toast.clear();
                    that.isLoading = false;
                }
            }

            images.forEach((img) => {
                img.addEventListener("load", () => {
                    loadedCount++;
                    checkAllImagesLoaded();
                });

                img.addEventListener("error", () => {
                    console.log(`图片加载失败：${img.src}`);
                    loadedCount++;
                    checkAllImagesLoaded();
                });
            });
        },
        scrollToTop() {
            this.isShare = false;
            console.log("scrollToTop", this.isShare);

            // 返回顶部
            // document.getElementById("contents").scrollTo({ top: 0, behavior: "smooth" });
            window.scrollTo({
                top: 0,
                behavior: "smooth", // 平滑滚动
            });
        },
        goShare() {
            let data = {
                // id: JSON.stringify([0, this.collectId || 0]),
                id: JSON.stringify([
                    this.oCategory.goods[0].id,
                    this.oCategory.goods[1].id,
                ]),
                isShare: this.isShare,
                category: JSON.stringify(this.oCategory),
            };
            console.log(data);
            wx.miniProgram.postMessage({
                data: {
                    // id: JSON.stringify([0, this.collectId || 0]),
                    id: JSON.stringify([
                        this.oCategory.goods[0].id,
                        this.oCategory.goods[1].id,
                    ]),
                    isShare: this.isShare,
                    category: JSON.stringify(this.oCategory),
                },
            });
        },
        handleScroll() {
            if (this.scrollTimer) {
                clearTimeout(this.scrollTimer);
                this.scrollTimer = null;
            }
            this.scrollTimer = setTimeout(() => {
                // let width = window.innerWidth;
                // let height = window.innerHeight;
                let closeItem = document.querySelector(".box-close");
                let closeHeight = closeItem.clientHeight;
                let closeTop = closeItem.getBoundingClientRect().top;
                console.log(closeTop, closeHeight);
                let lastItem = document.querySelector(".parameter-box-last");
                let lastTop = lastItem.getBoundingClientRect().top;
                console.log(lastTop);
                if (closeTop > lastTop) {
                    closeItem.style.top = "200px";
                } else {
                    closeItem.style.top = "";
                }
                // const currentScrollTop =
                //     window.scrollY || document.documentElement.scrollTop;
                // const distance = Math.abs(
                //     currentScrollTop - this.lastScrollTop
                // );
                // if (currentScrollTop > this.lastScrollTop) {
                //     // 向下滚动
                //     this.scrollDownDistance += distance;
                //     console.log("向下滚动");
                //     this.boxClose = top - currentScrollTop / 1000;
                // } else {
                //     // 向上滚动
                //     this.scrollUpDistance += distance;
                //     console.log("向上滚动");
                //     this.boxClose = top + currentScrollTop / 1000;
                // }
                // this.lastScrollTop = currentScrollTop;
                // console.log("boxClose1", this.boxClose);
                // this.boxClose = top - scrollTop / 1000;
                // console.log("boxClose2", this.boxClose);
            }, 50);
        },
        getHeight() {
            setTimeout(function () {
                const h = document.querySelector(".box-close");
                console.log(h.getBoundingClientRect().top);
                let height;
                // 获取高度
                const height1 =
                    document.querySelector(".pkv4-scroll").clientHeight;
                const bottomBox = document.querySelector(".bottom-box");
                const height2 = bottomBox ? bottomBox.clientHeight : 0;
                const height3 = document.querySelector(
                    ".parameter-box-last"
                ).clientHeight;
                const height4 =
                    document.querySelector(".pk-product").clientHeight;
                const editArea = document.querySelector(".edit-area");
                const height5 = editArea ? editArea.clientHeight : 0;

                this.boxBottom = height2 + height3 + 32;
                this.boxClose = height4 - 0 + height5 + 32;

                height = height1 - this.boxBottom - height4 - height5;
                console.log(
                    this.boxBottom,
                    this.boxClose,
                    "Element Height:",
                    height,
                    height1,
                    height2,
                    height3,
                    height4
                );
                this.boxTop = height4 + height5 - 8;
                console.log("boxTop", this.boxTop);
                document.querySelector(".share-box").style.height = height
                    ? height + "px"
                    : "100%";
                document.querySelector(".share-box").style.top = this.boxTop
                    ? this.boxTop + "px"
                    : "175px";
                const pkBottom = document.querySelector(".pkv4-bottom");
                console.log("pkBottom", pkBottom.clientHeight);
                this.pkBottom = pkBottom.clientHeight || 0;
                document.querySelector(".share_hint").style.bottom =
                    this.pkBottom + "px";
            }, 500);
        },
        adjustTextareaHeight() {
            const textarea = this.$refs.textarea.$el.querySelector("textarea");
            if (textarea) {
                textarea.style.height = "auto"; // Reset height to auto to get the new scrollHeight
                textarea.style.height = `${textarea.scrollHeight}px`; // Set height to scrollHeight
                console.log(textarea.style.height);
            }
        },
        touchEdit() {
            this.isEdit = !this.isEdit;
            if (!this.isEdit) {
                this.oCategory.goods[0].recom_reason = this.recom_reason;
                console.log(
                    "调用接口保存",
                    this.oCategory.goods[0],
                    this.recom_reason
                );
                // this.$message({ type: "success", message: "保存成功" });
                Toast({
                    message: "保存成功",
                    duration: 1200,
                });
            }
        },
        setFontSize() {
            const htmlEl = document.getElementsByTagName("html")[0];
            let width = window.innerWidth;
            if (width > 2224) {
                width = 2224;
            }
            htmlEl.style.fontSize = (width * 1) / 10.24 + "px";

            let tid = null;
            window.addEventListener(
                "resize",
                function () {
                    if (tid) {
                        clearTimeout(tid);
                    }
                    tid = setTimeout(() => {
                        const htmlEl = document.getElementsByTagName("html")[0];
                        let width = window.innerWidth;
                        if (width > 2224) {
                            width = 2224;
                        }
                        htmlEl.style.fontSize = (width * 1) / 10.24 + "px";
                    }, 300);
                },
                false
            );
        },
        restoreFontSize() {
            // const htmlEl = document.getElementsByTagName("html")[0];
            // htmlEl.style.fontSize = "";
        },
        getGoodsComparesFun() {
            return new Promise((resolve, reject) => {
                this.isPad = this.query.isPad ? true : false;
                let ids = this.query.id;
                ids = JSON.parse(ids);
                if (ids[0] == 0 && !this.isCollectInfo) {
                    this.isCollectInfo = true;
                    oApi.getGoodsShareCompareInfo({ id: ids[1] })
                        .then((res) => {
                            // console.log(res);
                            let oCategory = JSON.parse(res.result.compare_data);
                            const filteredData = oCategory.attr.map((item) => ({
                                ...item,
                                list: item.list.filter(
                                    (subItem) => subItem.isSelect
                                ),
                            }));
                            oCategory.attr = filteredData;
                            this.oCategory = oCategory;
                            console.log("收藏详情", this.oCategory);
                            this.recom_reason =
                                this.oCategory.goods[0].recom_reason;
                            this.has_reason = this.oCategory.goods[0]
                                .recom_reason
                                ? true
                                : false;
                            this.oCategory.goods[0].album.forEach((item) => {
                                this.albumLeft.push(item.file_url);
                            });
                            this.oCategory.goods[1].album.forEach((item) => {
                                this.albumRight.push(item.file_url);
                            });
                            resolve();
                        })
                        .catch((err) => {
                            console.log(err, "getGoodsShareCompareInfo err");
                            reject();
                        });
                } else if (ids && ids.length > 1) {
                    let params = {
                        goods_ids: ids.join(","),
                        only_diff: this.isAll ? 1 : 0,
                        is_price: this.isPriority ? 1 : 0,
                    };

                    oApi.getGoodsCompares(params)
                        .then((res) => {
                            let data = res.result.category;
                            if (data && data.length > 0) {
                                this.oCategory = data[0];
                            }
                            if (
                                this.oCategory.goods &&
                                this.oCategory.goods.length > 1
                            ) {
                                this.oCategory.goods.forEach((item, index) => {
                                    //处理3d链接
                                    if (
                                        item.td_link_url &&
                                        item.td_param &&
                                        item.td_param.length > 0
                                    ) {
                                        // console.log(item.td_link_url);
                                        let td_link = encodeURIComponent(
                                            item.td_link_url
                                        );
                                        let td_model = encodeURIComponent(
                                            item.goods_name
                                        );
                                        let td_style = encodeURIComponent(
                                            item.td_style
                                        );
                                        let td_param = JSON.stringify(
                                            item.td_param
                                        );
                                        let parameter = `url=${td_link}&model=${td_model}&style=${td_style}&link=${td_param}`;

                                        let host;
                                        if (
                                            process.env.VUE_APP_FLAG ==
                                            "production"
                                        ) {
                                            host =
                                                "https://aosmithv2.iwxapi.com/model/preview/index";
                                        } else {
                                            host =
                                                "https://aotest2.iwxapi.com/model/preview/index";
                                        }
                                        item.link = `${host}?${parameter}`;
                                    }
                                });
                                this.recom_reason =
                                    this.oCategory.goods[0].recom_reason;
                                this.has_reason = this.oCategory.goods[0]
                                    .recom_reason
                                    ? true
                                    : false;
                                this.oCategory.goods[0].album.forEach(
                                    (item) => {
                                        this.albumLeft.push(item.file_url);
                                    }
                                );
                                this.oCategory.goods[1].album.forEach(
                                    (item) => {
                                        this.albumRight.push(item.file_url);
                                    }
                                );
                            }
                            if (
                                this.oCategory.topic &&
                                this.oCategory.topic.length > 1
                            ) {
                                this.oCategory.topic.forEach((item, index) => {
                                    item.nScore = Math.round(item.score || 0);
                                    // console.log(item.topic_tag);
                                    if (item.topic_tag) {
                                        item.arrTag = item.topic_tag.split(",");
                                    }
                                });
                            }

                            if (
                                this.oCategory.attr &&
                                this.oCategory.attr.length > 0
                            ) {
                                // 插入上市日期
                                let attr = JSON.parse(
                                    JSON.stringify(this.oCategory.attr)
                                );
                                if (
                                    this.oCategory.goods[0]?.listing_date ||
                                    this.oCategory.goods[1]?.listing_date
                                ) {
                                    let newItem = {
                                        key_name: "",
                                        list: [
                                            {
                                                attr_item: [
                                                    this.oCategory.goods[0]
                                                        ?.listing_date || "-",
                                                    this.oCategory.goods[1]
                                                        ?.listing_date || "-",
                                                ],
                                                attr_name: "上市日期",
                                            },
                                        ],
                                    };
                                    attr.splice(1, 0, newItem);
                                    // console.log(newItem, attr);
                                }

                                // console.log(newItem, attr);
                                let newItem1 = {
                                    key_name: "",
                                    list: [
                                        {
                                            attr_item: [
                                                this.oCategory.goods[0]
                                                    ?.sales_count || "0",
                                                this.oCategory.goods[1]
                                                    ?.sales_count || "0",
                                            ],
                                            attr_name: "销售台数",
                                        },
                                    ],
                                };
                                if (this.isPriority) {
                                    attr.splice(2, 0, newItem1);
                                } else {
                                    attr.splice(attr.length, 0, newItem1);
                                }

                                // console.log(newItem1, attr);
                                this.oCategory.attr = attr;
                                this.oCategory.attr.forEach((item, index) => {
                                    item.isSelect = true;
                                    item.isAllSelect = true;

                                    item.list.forEach((item2, index2) => {
                                        item2.isSelect = true;
                                    });
                                });
                            }
                            resolve();
                        })
                        .catch((err) => {
                            console.log(err, "getGoodsComparesFun err");
                            reject();
                        });
                } else {
                    this.$toast("缺少商品ID");
                    reject();
                }
            });
        },
        touchSame() {
            this.isAll = !this.isAll;
            this.getGoodsComparesFun();
            this.getHeight();
        },
        touchSelectAll() {
            if (this.oCategory.attr && this.oCategory.attr.length > 0) {
                this.oCategory.attr.forEach((item, index) => {
                    item.isSelect = true;
                    item.isAllSelect = true;

                    item.list.forEach((item2, index2) => {
                        item2.isSelect = true;
                    });
                });
                this.$forceUpdate();
                console.log(this.oCategory);
                this.goShare();
            }
        },
        touchSelectAttr(attr, index) {
            console.log(attr, index);
            const isCurrentlyHalfSelected = attr.isSelect && !attr.isAllSelect;
            if (isCurrentlyHalfSelected) {
                // 如果当前是半选状态，切换到全选
                this.oCategory.attr[index].isAllSelect = true;
                this.oCategory.attr[index].list.forEach((item) => {
                    item.isSelect = true;
                });
            } else {
                // 否则，正常切换选中状态
                const value = !attr.isSelect;
                this.oCategory.attr[index].isSelect = value;
                this.oCategory.attr[index].isAllSelect = value;
                this.oCategory.attr[index].list.forEach((item) => {
                    item.isSelect = value;
                });
            }
            this.$forceUpdate();
            console.log(this.oCategory);
            this.goShare();
        },
        touchSelectItem(item, index, i) {
            const value = !item.isSelect;
            this.oCategory.attr[index].list[i].isSelect = value;

            let num = 0;
            this.oCategory.attr[index].list.forEach((item2, index2) => {
                if (item2.isSelect) {
                    num = num + 1;
                }
            });

            if (num == this.oCategory.attr[index].list.length) {
                this.oCategory.attr[index].isSelect = true;
                this.oCategory.attr[index].isAllSelect = true;
            } else if (num == 0) {
                this.oCategory.attr[index].isSelect = false;
                this.oCategory.attr[index].isAllSelect = false;
            } else {
                this.oCategory.attr[index].isSelect = true;
                this.oCategory.attr[index].isAllSelect = false;
            }
            this.$forceUpdate();
            console.log(this.oCategory);
            this.goShare();
        },
        cutFun(i) {
            console.log("返回上一页", i);
            wx.miniProgram.postMessage({
                data: {
                    pk_id: i,
                },
            });
            wx.miniProgram.navigateBack({
                delta: 1,
            });
            // wx.miniProgram.navigateTo({
            //     url: `/productc/pagesv2/productc/productc?pk_id=${i}`,
            // });
        },
        linkFun(link) {
            window.open(link);
        },
        backFun() {
            this.$router.back();
        },
        touchPriority() {
            console.log(this.isPriority);
            this.isShare = false;
            this.getGoodsComparesFun();
            this.getHeight();
        },
        touchCollect() {
            let params = {
                compare_id:
                    this.oCategory.goods[0].id +
                    "," +
                    this.oCategory.goods[1].id,
                compare_data: JSON.stringify(this.oCategory),
            };
            console.log(params, this.oCategory);
            oApi.getGoodsShareCompares(params)
                .then((res) => {
                    console.log(res);
                    Toast.success("收藏成功");
                    this.collectId = res.result.id;
                })
                .catch((err) => {
                    console.log(err);
                    Toast.fail(err.msg);
                });
        },
        touchShare() {
            if (this.isShare) {
                console.log(1);
                // console.log(this.isFirst, "展示分享", this.oCategory);
                if (!this.isFirst) {
                    console.log(2);
                    this.isFirst = true;
                    this.isShare = !this.isShare;
                    // if (!this.isShare) {
                    //     this.isShare = true;
                    // }
                    // return;
                } else {
                    console.log(3);
                    this.showGuide = true;
                    this.scrollToTop();
                    let timer1 = setTimeout(() => {
                        this.showGuide = false;
                        clearTimeout(timer1);
                    }, 5000);
                    this.isFirst = false;
                }
            } else {
                console.log(4);
                this.isFirst = true;
                this.isShare = true;

                // this.isShare = !this.isShare;
            }
            console.log(this.isShare, 5);
        },
        onChangeLeft(nIndex) {
            this.nBannerIndexLeft = nIndex;
            // this.scrollToIndicator(nIndex);
        },
        onChangeRight(nIndex) {
            this.nBannerIndexRight = nIndex;
            // this.scrollToIndicator(nIndex);
        },
        touchMoreShow(id) {
            console.log(id);
            wx.miniProgram.navigateTo({
                url: `/productc/pagesv2/goods_detail/index?itemid=${id}&isInfo=1`,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss" scoped>
#imageContainer {
    width: 1px;
    height: 1px;
    position: absolute;
}
.guide {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    // touch-action: none; /* 禁用触控滑动 */
    // background: rgba(0, 0, 0, 0.6);

    .share_hand {
        width: 90px;
        height: 121px;
        margin: 25px 110px 0 auto;
        display: block;
    }

    .share_hint {
        position: absolute;
        // top: 50%;
        // bottom: 0%;
        left: 50%;
        // transform: translate(-50%, -50%);
        transform: translateX(-50%);
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        padding: 40px 0;

        p {
            font-size: 43px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 48px;
            text-align: center;
        }
    }

    .share_icon {
        width: 108px;
        height: 108px;
        display: block;
        margin: 0 auto 65px;
    }
}
</style>
